import { render, staticRenderFns } from "./ArticulosPromocionales.vue?vue&type=template&id=446634f4&"
import script from "./ArticulosPromocionales.vue?vue&type=script&lang=js&"
export * from "./ArticulosPromocionales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports